<template>
    <div class="animated fadeIn gofixTab contractEquipmentTab assetManagement bgV2">
        <div class="boxShadow h-100 setBorderRadius">
            <div :class="['d-flex h-100 position-relative', {'assetManagement-collapse': is_hide}]">
                <div class="assetManagement-left h-100" ref="panelLeft">
                    <template>
                        <gofix-card title="property" class="contractTree contractEquimentTree" v-bind:class="{'run-loading':loading.property}" >
                            <template slot="gofixCard:right_header">
                                <div class="cursor-pointer" @click="collapse">
                                    <img src="img/unfold_right.png" alt="icon" width="8px" height="12px">
                                    <img src="img/unfold_left.png" alt="icon" width="8px" height="12px" class="ml-4-px">
                                </div>
                            </template>
                            <div class="contenAbsolute">
                                <div class="tree-view-properties">
                                    <tree :data="propertyData" :options="propertyOpts" @node:clicked="selectNodeProperty" ref="treeViewProperties">
                                        <div slot-scope="{ node }" class="node-container">{{ node.text }}</div>
                                    </tree>
                                </div>
                            </div>
                        </gofix-card>
                    </template>
                </div>
                <div class="assetManagement-right h-100" ref="rightPanel">
                    <property-schedule name-table="preventive-maintenance-property-schedule" :settings="settings" :general="general" @change-maint="reloadTreeData" @loadProperty="reloadProperty" ref="propertySchedule"></property-schedule>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import LiquorTree from "liquor-tree";
    const propertySchedule = () => import("./property-schedule.vue")
   
    export default {
        name: "property-schedule-list",
        components: {
            [LiquorTree.name]: LiquorTree,
            propertySchedule
        },
        data() {
            return {
                is_hide: false,
                settings: {
                    showBtnMassSchedule: true,
                    showDropDownMaint: true,
                },
                propertyData: [],
                propertyOpts: {
                    minFetchDelay: 500,
                    fetchData: node => {
                        node.isBatch = false;
                        if(node.data.id == this.general.root_property_id) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }
                        return new Promise((resolve, reject) => {
                            global
                                .axios(
                                    `api/contracts/${this.general.contract_id}/tree-properties/${node.data.id}`, {
                                        method: "GET",
                                        params: {
                                            is_active: true
                                        },
                                        headers: {
                                            Accept: "application/json"
                                        }
                                    }
                                )
                                .then(response => {
                                    resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        });
                    }
                },
                replace: function(key, value) {
                    switch (key) {
                        case "children":
                            if (value.length > 0) {
                                return value;
                            } else {
                                return null;
                            }
                            break;
                        default:
                            return value;
                    }
                },
                loading: {
                    property: false
                },
                general: {
                    contract_id: null,
                    contract_term_id: null,
                    property_id: 0,
                    root_property_id: 0,
                }
            }
        },
        watch: {
            ClientContractID: function(val, old) {
                if(val && val.id) {
                    this.general.contract_id      = val.id;
                    this.general.contract_term_id = val && val.contract_terms && val.contract_terms[0] ? val.contract_terms[0].id : null;
                    this.general.property_id = 0;
                    if(this.$refs.treeViewProperties) this.$refs.treeViewProperties.setModel([]);
                    this.getPropertyData();
                    return;
                }

                this.general.contract_id = null;
                this.general.contract_term_id = 0;
                this.general.property_id = 0;
                if(this.$refs.treeViewProperties) this.$refs.treeViewProperties.setModel([]);
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: "ContractController/ClientContractID"
            })
        },
        mounted() {
            /*this.$refs.treeViewProperties.$on("tree:mounted", data => {
                this.dataLocationModal = JSON.parse(
                    JSON.stringify(this.$refs.treeViewProperties.toJSON(), this.replace)
                );
            });
            this.$refs.treeViewProperties.$on("tree:data:received", data => {
                this.dataLocationModal = JSON.parse(
                    JSON.stringify(this.$refs.treeViewProperties.toJSON(), this.replace)
                );
            });
            this.$refs.treeViewProperties.$on("node:selected", data => {
                this.dataLocationModal = JSON.parse(
                    JSON.stringify(this.$refs.treeViewProperties.toJSON(), this.replace)
                );
            });*/
        },
        created() {
            if(this.ClientContractID && this.ClientContractID.contract_terms){
                this.general.contract_id      = this.ClientContractID.id;
                this.general.contract_term_id = this.ClientContractID && this.ClientContractID.contract_terms && this.ClientContractID.contract_terms[0] ? this.ClientContractID.contract_terms[0].id : null;
                this.getPropertyData();
            }
        },
        methods: {
            collapse() {
                this.is_hide = !this.is_hide;
                let left = this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.left;
                let maxRight = this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.scrollAreaWidth - this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.scrollWrapperWidth;
                if(this.is_hide && (left >= maxRight)) {
                    this.$nextTick(() => {
                        this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.normalizeHorizontal(left - this.$refs.panelLeft.clientWidth);
                        let time = setTimeout(() => {
                            this.$refs.propertySchedule.$refs.gofixTable.$refs.vueScrollbar.calculateSize();
                            clearTimeout(time);
                        }, 500);
                    });
                }
            },
            reloadTreeData(val) {
            },
            /* --- Tree Property --- */
            getPropertyData() {
                this.loading.property = true;
                return new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${this.general.contract_id}/tree-properties/${this.general.property_id}`, {
                        method: "GET",
                        params: {
                            is_active: true
                        },
                        headers: {
                            Accept: "application/json"
                        }
                    })
                    .then(response => {
                        response.data.data[0].state.selected = true;
                        this.loading.property = false;
                        this.general.root_property_id = response.data.data[0].id
                        this.$refs.treeViewProperties.setModel(response.data.data);
                        if(this.general.property_id == 0) this.general.property_id =this.general.root_property_id;
                    })
                    .catch(error => {
                        this.loading.property = false;
                    });
                });
            },
            selectNodeProperty(node) {
                if(node && node.id && node.id != 'all') {
                    this.general.property_id = node.id;
                }
            },
            reloadProperty() {
                this.general.property_id = 0;
                this.$refs.treeViewProperties.setModel([]);
                this.getPropertyData();
            }
        }
    }
</script>